import { useEffect, useState } from "react";

import { Lesson } from "@/types";

export function useLessonTimer(lessonInfo: Lesson | null, isSandbox = false) {
  const [actualRemainingMinutes, setActualRemainingMinutes] = useState(0);

  const effectiveDuration = isSandbox
    ? 60
    : lessonInfo
      ? lessonInfo.hasStarted
        ? lessonInfo.duration
        : lessonInfo.introDuration
      : 0;

  useEffect(() => {
    if (isSandbox) return;
    if (!lessonInfo?.startDateTime) return;

    const updateTimes = () => {
      const currentTime = Date.now();
      const startTime = lessonInfo.startDateTime.toDate().getTime();
      const elapsedTime = Math.floor((currentTime - startTime) / 60000);
      const remainingTime = effectiveDuration - elapsedTime;
      setActualRemainingMinutes(
        Math.max(0, Math.min(effectiveDuration, remainingTime))
      );
    };

    updateTimes();
    const intervalId = setInterval(updateTimes, 1000);
    return () => clearInterval(intervalId);
  }, [lessonInfo, effectiveDuration, isSandbox]);

  const remainingMinutes = isSandbox ? 50 : actualRemainingMinutes;

  const effectiveDurationSeconds = effectiveDuration * 60;
  const remainingTimeSeconds = remainingMinutes * 60;
  const progressPercent =
    effectiveDurationSeconds > 0
      ? ((effectiveDurationSeconds - remainingTimeSeconds) /
          effectiveDurationSeconds) *
        100
      : 0;

  return {
    effectiveDuration,
    remainingMinutes,
    progressPercent,
  };
}
